import { errorJSONStringify } from '@/utils/utils'
import { checkPremium } from '@weathernews/btos-javascript-modules/src/wniutil/auth.js'
import { ref } from 'vue'

export default defineNuxtPlugin(async (nuxtApp) => {
  const isPremium = ref(false)

  try {
    await checkPremium()
    isPremium.value = true
  } catch (error) {
    console.log(errorJSONStringify(error))
    isPremium.value = false
  }

  nuxtApp.provide('isPremium', isPremium)
})
